var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPngicon = function SvgPngicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.496 1.6h-12.8a1.6 1.6 0 0 0-1.6 1.6v9.6a1.6 1.6 0 0 0 1.6 1.6h12.8a1.6 1.6 0 0 0 1.6-1.6V3.2a1.6 1.6 0 0 0-1.6-1.6Zm0 10.264a.392.392 0 0 1-.4.4.384.384 0 0 1-.32-.16l-3.56-4.744a.408.408 0 0 0-.64 0l-2.28 2.968a.408.408 0 0 1-.32.16.392.392 0 0 1-.304-.144l-1.184-1.4a.4.4 0 0 0-.312-.144.416.416 0 0 0-.312.152l-2.456 3.152a.384.384 0 0 1-.312.152.392.392 0 0 1-.4-.4V3.2h12.8v8.664ZM6.096 4.8a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4Z",
    clipRule: "evenodd"
  })));
};
export default SvgPngicon;